



































































































































































































































import http from '@/utils/http'
import geonorge from '@/utils/geonorge'
import { debounce } from 'ts-debounce'
import moment from 'moment'
import { Component, Vue, Watch } from 'vue-property-decorator'
import AddressBox from '@/components/AddressBox.vue'
import { Product } from '@/models/Product'
import { Address } from '@/models/Address'
import { Coverage } from '@/models/Coverage'
import { Offer } from '@/models/Offer'

const GenericErrorMessage = 'OBS! Noe gikk galt. Prøv igjen.<br/>Kontakt oss på telefon 23 29 42 00 om feilen vedvarer.'

@Component({
  components: {
    AddressBox
  }
})
export default class CoverageView extends Vue {

  get canCheck() {
    return this.municipalityNumber !== '' && this.buildingNumber !== '' && this.unitNumber !== ''
  }

  get canShowTest() {
    return this.$store.state && this.$store.state.user && this.$store.state.user.email === 'stian@eonbit.com'
  }

  get isButtonBlock() {
    // window.vv = this.$vuetify.breakpoint
    return this.$vuetify.breakpoint.xs
  }

  get hasTerms() {
    const terms = this.terms
    return (terms && terms.length > 0)
  }

  get terms() {
    if (!this.coverage || !this.coverage.terms) {
      return []
    }
    const result = []
    for (const term of this.coverage.terms) {
      result.push({ id: term, name: term + ' mnd'})
    }
    return result
  }


  get products() {
    if (!this.coverage) {
      return []
    }
    if (!this.isOrder) {
      return this.coverage.products || []
    }
    const result = []
    for (const product of this.coverage.products) {
      if (!this.hasProductPriceForTerm(product)) {
        continue
      }
      result.push(product)
    }
    return result
  }

  // Common
  private isLoading = false
  private errorMessage = ''
  private stepper = 0
  private executeAddressSearch!: () => void
  private isOrder = false

  // Select address
  private addressSearchSync = null
  private municipalityNumber = ''
  private buildingNumber = ''
  private unitNumber = ''
  private addressQuery = ''
  private addressResults: Address[] = []
  private addressSelected: Address = new Address()

  // Check coverage
  private coverage: Coverage|null = null

  // Request offer
  private offer: Offer = new Offer()
  private offerRequestId: string = ''
  private requestedDeliveryDateMenu: boolean = false

  // ===========================================================
  // Search address
  // ===========================================================

  @Watch('addressSearchSync')
  public watchAddressSearch(value: string) {
    if (!this.executeAddressSearch) {
      this.executeAddressSearch = debounce(() => {
        this._executeAddressSearch()
      }, 300)
    }
    this.executeAddressSearch()
  }

  public _executeAddressSearch() {
    const value = this.addressSearchSync
    if (!value) {
      return
    }
    this.clearError()
    this.isLoading = true
    geonorge.searchByQuery(value, '0301') // todo: filter other than oslo (0301) ?
      .then((addresses: Address[]) => {
        this.addressResults = addresses
        this.isLoading = false
      })
      .catch((err: Error) => {
        this.setError(GenericErrorMessage, 'Address search failed', err)
        this.isLoading = false
      })
  }

  public reset() {
    this.addressQuery = ''
    this.municipalityNumber = ''
    this.buildingNumber = ''
    this.unitNumber = ''
    this.offer = new Offer()
    this.setStep(1, false)
  }

  @Watch('municipalityNumber')
  public watchMunicipalityNumber(value: string) {
    if (this.addressSelected) {
      if (this.addressSelected.municipalityNumber !== value) {
        this.addressSelected = new Address()
        this.addressQuery = ''
      }
    }
  }

  @Watch('buildingNumber')
  public watchBuildingNumber(value: string) {
    if (this.addressSelected) {
      if (this.addressSelected.buildingNumber !== value) {
        this.addressSelected = new Address()
        this.addressQuery = ''
      }
    }
  }

  @Watch('unitNumber')
  public watchUnitNumber(value: string) {
    if (this.addressSelected) {
      if (this.addressSelected.unitNumber !== value) {
        this.addressSelected = new Address()
        this.addressQuery = ''
      }
    }
  }

  public onAddressSelected(a: string) {
    this.addressSelected = new Address()
    this.addressResults.forEach((r) => {
      if (r.fullId === a) {
        this.addressSelected = r
      }
    })
    if (this.addressSelected) {
      this.municipalityNumber = this.addressSelected.municipalityNumber
      this.buildingNumber = this.addressSelected.buildingNumber
      this.unitNumber = this.addressSelected.unitNumber
    } else {
      this.municipalityNumber = ''
      this.buildingNumber = ''
      this.unitNumber = ''
    }
  }

  // ===========================================================
  // Check coverage
  // ===========================================================

  public check() {
    this.clearError()
    this.isLoading = true
    geonorge.searchByNumbers(this.municipalityNumber, this.buildingNumber, this.unitNumber)
      .then((addresses: Address[]) => {
        if (addresses.length > 0) {
          // Only set address from backend (ie. from KGB number) if one was not searched for already.
          // Since a KGB can have multiple addresses, we want to preserve the one they searched for.
          // Though it is also possible to search directly by KGB, and if so we use the "first and best" from backend.
          let explicitlySelectedAddress = ''
          if (!this.addressSelected || this.addressSelected.isEmpty()) {
            this.addressSelected = addresses[0]
          } else {
            explicitlySelectedAddress = this.addressSelected.getFullAddressText()
          }
          const addressCode = this.municipalityNumber + '-' + this.buildingNumber + '-' + this.unitNumber
          const checkUrl = '/coverage/check' +
            '?addressCode=' + addressCode +
            '&addressDescription=' + explicitlySelectedAddress
          http.get(checkUrl)
            .then((response: any) => {
              const data = response && response.data ? response.data : {}
              this.coverage = new Coverage()
              this.coverage.covered = data.covered
              this.coverage.estimatedDeliveryTime = data.estimatedDeliveryTime
              const products: Product[] = []
              data.products.forEach((v: Record<string, unknown>) => {
                products.push(new Product(v))
              })
              this.coverage.products = products
              this.coverage.propertyId = data.propertyId
              this.coverage.terms = data.terms
              this.isLoading = false
              this.setStep(2, false)
            })
            .catch((err: Error) => {
              this.setError(GenericErrorMessage, 'Coverage check failed', err)
              this.isLoading = false
            })
        } else {
          this.setError('Ugyldig adresse. Prøv igjen.')
          this.isLoading = false
        }
      })
      .catch((err: Error) => {
        this.setError(GenericErrorMessage, 'Error verifying address', err)
        this.isLoading = false
      })
  }

  public getMinimumDeliveryDate() {
    if (this.coverage && this.coverage.covered) {
      return moment(this.coverage.estimatedDeliveryTime).format('YYYY-MM-DD')
    }
    return moment().format('YYYY-MM-DD')
  }

  public getDisplayDeliveryDate(check: Coverage|null) {
    if (!check) {
      return ''
    }
    const m = moment(check.estimatedDeliveryTime)
    // return m.format('YYYY-MM-DD')
    const months = [
      'januar',
      'februar',
      'mars',
      'april',
      'mai',
      'juni',
      'juli',
      'august',
      'september',
      'oktober',
      'november',
      'desember'
    ]
    return m.format('D') + '. ' + months[m.month()] + ' ' + m.format('YYYY')
  }

  public getDisplayDeliveryDays(check: Coverage|null) {
    if (!check) {
      return ''
    }
    const m = moment(check.estimatedDeliveryTime)
    return m.diff(moment(), 'days') + 1
  }

  // ===========================================================
  // Request offer
  // ===========================================================

  public requestOffer() {
    if (!this.offer.productId) {
      this.setError('Du må velge et produkt')
      return
    }
    this.offer.address = '' +
      this.addressSelected.streetAddress + ', ' +
      this.addressSelected.postalCode + ' ' + this.addressSelected.city
    this.offer.municipalityNumber = this.addressSelected.municipalityNumber
    this.offer.buildingNumber = this.addressSelected.buildingNumber
    this.offer.unitNumber = this.addressSelected.unitNumber
    this.offer.propertyId = this.coverage ? this.coverage.propertyId : null
    this.offer.isOrder = this.isOrder
    http.post('/coverage/offer', this.offer)
      .then((response: any) => {
        this.offerRequestId = '' + response.data.offerRequestId
        this.isLoading = false
        this.setStep(4, this.isOrder)
      })
      .catch((err: Error) => {
        this.setError(GenericErrorMessage, 'Offer request failed', err)
        this.isLoading = false
      })
  }

  public hasProductPriceForTerm(product: Product): boolean {
    if (!this.offer || !this.offer.term) {
      return false
    }
    const price = product.prices[this.offer.term] || ''
    return !!price
  }

  // ===========================================================
  // Utils
  // ===========================================================

  private setStep(step: number, isOrder: boolean) {
    this.stepper = step
    this.isOrder = isOrder
    this.clearError()
  }

  private clearError() {
    this.setError('')
  }

  private setError(displayMessage: string, internalMessage?: string, error?: any) {
    this.errorMessage = displayMessage
    if (internalMessage) {
      // tslint:disable:no-console
      console.error('ERROR: ' + internalMessage, error)
    }
    /*
    if (error) {
      this.errorMessage += ' (' + error + ')'
    }
    */
  }

  private getProductNameWithPrice(product: Product): string {
    let price = ''
    if (this.offer && this.offer.term) {
      price = product.prices[this.offer.term] || ''
    }
    if (price) {
      return product.name + ' (' + price + ' kr)'
    } else {
      return product.name
    }
  }

}
